import * as React from 'react';
import classNames from 'classnames';
import { Form, Tooltip } from 'antd';
import './validation.scss';
import Icon from 'atoms/icons/icon';
import { getGridMetadata } from 'models/dynamicGrid/selector';
import { useSelector } from 'react-redux';
import { isUndefined } from 'lodash';
import { usePopupParent } from 'hooks/usePopupParent';

const isOrderQtyField = (identifier: string) =>
	identifier === 'OrderQty' || identifier === 'ItemOrderQty' || identifier?.includes('|ItemOrderQty');

const Validation = (props: any) => {
	const [touched, setTouched] = React.useState(false);
	const { children, hasError, errorMessage, hasWarning, value, tableId, row, rowIdentifier } = props;
	const gridMetaData = useSelector((state) => getGridMetadata(state, tableId));
	const getPopupParent = usePopupParent('full-screen');
	const hasGridEditOperationDisabled = gridMetaData?.dataProviderOptions?.isGridEditDisabledOverride;

	React.useEffect(() => {
		if (isUndefined(value)) return;
		else setTouched(true);
		return () => {
			setTouched(false);
		};
	}, [value]);

	const isUpdated = row?.[rowIdentifier]?.isUpdated;
	const showBlueHighlight = isUpdated && isOrderQtyField(rowIdentifier);

	const classes: any = classNames([
		'validation-form-item',
		{ 'validation-form-item-theme': props.isTheme },
		{ 'validation-edit-disabled': hasGridEditOperationDisabled },
		{ 'validation-updated-cell': showBlueHighlight },
	]);
	return (
		<Form.Item
			className={classes}
			validateStatus={
				touched && (hasError || hasWarning) ? 'error' : undefined
			}
		>
			<div className="validation">
				<div className="validation--input" onBlur={() => setTouched(true)}>
					{children}
				</div>
				{touched && (hasError || hasWarning) && (
					<Tooltip
						getPopupContainer={getPopupParent}
						placement="topLeft"
						title={errorMessage}
						arrowPointAtCenter
					>
						<div>
							<Icon
								extraClass={hasWarning ? 'warning' : 'error'}
								faAlias="faInfoCircle"
								size="small"
							></Icon>
						</div>
					</Tooltip>
				)}
			</div>
		</Form.Item>
	);
};

export default Validation;
